exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui-notification{position:fixed;z-index:9999;width:300px;cursor:pointer;-webkit-transition:all .5s ease;transition:all .5s ease;color:#fff;border-radius:0;background:#337ab7;box-shadow:5px 5px 10px rgba(0,0,0,.3)}.ui-notification.killed{-webkit-transition:opacity 1s ease;transition:opacity 1s ease;opacity:0}.ui-notification>h3{font-size:14px;font-weight:700;display:block;margin:10px 10px 0;padding:0 0 5px;text-align:left;border-bottom:1px solid hsla(0,0%,100%,.3)}.ui-notification a{color:#fff}.ui-notification a:hover{text-decoration:underline}.ui-notification>.message{margin:10px}.ui-notification.warning{color:#fff;background:#f0ad4e}.ui-notification.error{color:#fff;background:#d9534f}.ui-notification.success{color:#fff;background:#5cb85c}.ui-notification.info{color:#fff;background:#5bc0de}.ui-notification:hover{opacity:.7}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./bower_components/angular-ui-notification/dist/angular-ui-notification.css
 ** module id = 186
 ** module chunks = 1
 **/